module.exports = __webpack_public_path__ + "static/media/attachment-icon.67d5792f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/attachment-icon.svg
// module id = 1244
// module chunks = 21